/* Styled By Valérie — interacties: header, menu, zoeken, productrij, reveal */
(function () {
  const doc = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  doc.classList.add('sbv-js');

  /* ---------- Header: transparant → vol, verbergen bij naar beneden scrollen ---------- */
  function initHeader() {
    const wrap = document.querySelector('[data-sbv-header]');
    const section = document.querySelector('.section-header');
    if (!wrap || !section) return;
    const transparent = wrap.hasAttribute('data-transparent');
    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
      const y = window.scrollY;
      const solidAt = transparent ? Math.max(60, window.innerHeight * 0.12) : 0;
      wrap.classList.toggle('is-solid', y > solidAt || wrap.matches(':hover') || wrap.querySelector('.is-open') !== null);
      const goingDown = y > lastY && y > 320;
      const menuOpen = document.body.classList.contains('sbv-lock');
      section.classList.toggle('is-hidden', goingDown && !menuOpen && !wrap.matches(':focus-within'));
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    if (transparent) {
      wrap.addEventListener('mouseenter', () => wrap.classList.add('is-solid'));
      wrap.addEventListener('mouseleave', update);
      wrap.addEventListener('focusin', () => wrap.classList.add('is-solid'));
    }
    update();

    // Uitklapmenu ook bedienbaar met toetsenbord en touch
    wrap.querySelectorAll('.sbv-header__item.has-mega').forEach((item) => {
      const trigger = item.querySelector(':scope > a');
      item.addEventListener('mouseenter', () => trigger.setAttribute('aria-expanded', 'true'));
      item.addEventListener('mouseleave', () => { trigger.setAttribute('aria-expanded', 'false'); item.classList.remove('is-open'); });
      trigger.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) {
          e.preventDefault();
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { item.classList.remove('is-open'); trigger.focus(); }
      });
    });
  }

  /* ---------- Fullscreen menu ---------- */
  function initMenu() {
    const menu = document.querySelector('[data-sbv-menu]');
    if (!menu) return;
    const openers = document.querySelectorAll('[data-sbv-menu-open]');
    let lastFocus = null;
    const open = () => {
      lastFocus = document.activeElement;
      menu.hidden = false;
      document.body.classList.add('sbv-lock');
      openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(() => requestAnimationFrame(() => menu.classList.add('is-open')));
      menu.querySelector('[data-sbv-menu-close]').focus({ preventScroll: true });
    };
    const close = () => {
      menu.classList.remove('is-open');
      document.body.classList.remove('sbv-lock');
      openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      setTimeout(() => { menu.hidden = true; }, reduceMotion ? 0 : 450);
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    };
    openers.forEach((b) => b.addEventListener('click', open));
    menu.querySelector('[data-sbv-menu-close]').addEventListener('click', close);
    menu.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    menu.addEventListener('click', (e) => {
      if (e.target.closest('a')) close();
      if (e.target.closest('[data-sbv-search-open]')) close();
    });
  }

  /* ---------- Zoeken ---------- */
  function initSearch() {
    const dlg = document.querySelector('[data-sbv-search]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    const input = dlg.querySelector('input[type="search"]');
    const open = (e) => {
      if (e) e.preventDefault();
      dlg.showModal();
      requestAnimationFrame(() => dlg.classList.add('is-open'));
      setTimeout(() => input.focus(), 50);
    };
    const close = () => {
      dlg.classList.remove('is-open');
      setTimeout(() => dlg.close(), reduceMotion ? 0 : 350);
    };
    document.addEventListener('click', (e) => { if (e.target.closest('[data-sbv-search-open]')) open(e); });
    dlg.querySelector('[data-sbv-search-close]').addEventListener('click', close);
    dlg.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
  }

  /* ---------- Productrij: pijlen + slepen met de muis ---------- */
  function initRails(root) {
    (root || document).querySelectorAll('[data-sbv-rail]').forEach((rail) => {
      if (rail.dataset.sbvReady) return;
      rail.dataset.sbvReady = '1';
      const track = rail.querySelector('[data-sbv-rail-track]');
      const prev = rail.querySelector('[data-sbv-rail-prev]');
      const next = rail.querySelector('[data-sbv-rail-next]');
      if (!track) return;
      const step = () => {
        const item = track.querySelector('.sbv-rail__item');
        return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth * 0.8;
      };
      const sync = () => {
        if (prev) prev.disabled = track.scrollLeft < 8;
        if (next) next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
      };
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
      sync();

      // Slepen met de muis (touch scrollt native)
      let down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      });
      window.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
        track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!down) return;
        down = false;
        if (moved) {
          const s = step();
          track.classList.remove('is-dragging');
          track.scrollTo({ left: Math.round(track.scrollLeft / s) * s, behavior: 'smooth' });
        }
      });
      track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    });
  }

  /* ---------- Reveal bij scrollen + zachte parallax ---------- */
  function initReveal(root) {
    const els = (root || document).querySelectorAll('[data-sbv-reveal]:not(.is-in)');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
    // Veiligheidsnet: alles zichtbaar na 3 s, ook als de observer iets mist
    setTimeout(() => els.forEach((el) => el.classList.add('is-in')), 3000);
  }

  function initParallax() {
    if (reduceMotion) return;
    const els = [...document.querySelectorAll('[data-sbv-parallax]')];
    if (!els.length) return;
    let ticking = false;
    const run = () => {
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        const f = parseFloat(el.dataset.sbvParallax) || 0;
        const offset = (r.top + r.height / 2 - vh / 2) * f;
        el.style.translate = `0 ${offset.toFixed(1)}px`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  function boot() {
    initHeader();
    initMenu();
    initSearch();
    initRails();
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme-editor: secties opnieuw initialiseren na wijzigen
  document.addEventListener('shopify:section:load', (e) => { initRails(e.target); initReveal(e.target); });
})();
